var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "j7hwck29aa",
    d: "M0.246 0.344L217.209 0.344 217.209 238.448 0.246 238.448z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC6F3",
    d: "M278.299 33.023h-97.39c-20.285 0-36.73 16.444-36.73 36.73v23.569h65.075c13.44 0 24.335 10.894 24.335 24.334v2.188c0 13.44-10.895 24.335-24.335 24.335H70.359c-20.287 0-36.732 16.445-36.732 36.73v97.389c0 20.286 16.445 36.731 36.732 36.731h23.567v-38.866c0-39.925 32.364-72.29 72.289-72.29h112.084c20.286 0 36.73-16.444 36.73-36.73v-97.39c0-20.285-16.444-36.73-36.73-36.73",
    transform: "translate(45 45)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M283.309 459.208H175.9c-36.033 0-65.348-29.315-65.348-65.348V286.452c0-36.033 29.315-65.348 65.348-65.348h107.408c26.659 0 48.348-21.689 48.348-48.348V65.348c0-26.66-21.69-48.348-48.348-48.348H175.9c-26.66 0-48.348 21.688-48.348 48.348v52.761h-17V65.348C110.553 29.314 139.868 0 175.9 0h107.408c36.033 0 65.348 29.314 65.348 65.348v107.408c0 36.033-29.315 65.348-65.348 65.348H175.9c-26.66 0-48.348 21.689-48.348 48.348V393.86c0 26.659 21.689 48.348 48.348 48.348h107.408c26.659 0 48.348-21.689 48.348-48.348v-50.794h17v50.794c0 36.033-29.315 65.348-65.348 65.348",
    transform: "translate(45 45)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M115.946 348.656H65.348C29.315 348.656 0 319.34 0 283.308V175.9c0-36.033 29.315-65.348 65.348-65.348h143.115c4.694 0 8.5 3.806 8.5 8.5s-3.806 8.5-8.5 8.5H65.348C38.69 127.552 17 149.24 17 175.9v107.408c0 26.659 21.69 48.348 48.348 48.348h50.598c4.694 0 8.5 3.806 8.5 8.5s-3.806 8.5-8.5 8.5",
    transform: "translate(45 45)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 45) translate(242 110.208)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n2edxpz3kb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j7hwck29aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M151.86 238.448H8.746c-4.695 0-8.5-3.806-8.5-8.5s3.805-8.5 8.5-8.5H151.86c26.66 0 48.35-21.69 48.35-48.348V65.692c0-26.66-21.69-48.348-48.35-48.348h-50.794c-4.694 0-8.5-3.806-8.5-8.5s3.806-8.5 8.5-8.5h50.794c36.033 0 65.35 29.315 65.35 65.348V173.1c0 36.033-29.317 65.348-65.35 65.348",
    mask: "url(#n2edxpz3kb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M192.595 65.348c0 9.22-7.475 16.695-16.694 16.695-9.221 0-16.696-7.475-16.696-16.695 0-9.221 7.475-16.695 16.696-16.695 9.219 0 16.694 7.474 16.694 16.695M266.613 393.86c0-9.22 7.475-16.695 16.695-16.695 9.221 0 16.696 7.475 16.696 16.695s-7.475 16.695-16.696 16.695c-9.22 0-16.695-7.475-16.695-16.695",
    transform: "translate(45 45)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPython);
export default __webpack_public_path__ + "static/media/icon--python.31e5767fb9dada369898bb6d5fc41c5d.svg";
export { ForwardRef as ReactComponent };